module.exports = __webpack_public_path__ + "img/add.d7c721b3.svg";